
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/access",
      function () {
        return require("private-next-pages/company/access.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/access"])
      });
    }
  